function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesWifiFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.13 10.097l1.414 1.414A17.499 17.499 0 0116 6.35c4.705 0 9.128 1.833 12.455 5.16l1.414-1.414A19.485 19.485 0 0016 4.352c-5.24 0-10.165 2.04-13.87 5.745z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.456 15.422c4.71-4.711 12.377-4.711 17.088 0l1.414-1.414c-5.492-5.491-14.426-5.489-19.916 0l1.414 1.414zM20.525 19.442A6.358 6.358 0 0016 17.567c-1.71 0-3.317.666-4.526 1.875l-1.414-1.415a8.345 8.345 0 015.94-2.46c2.243 0 4.353.873 5.94 2.46l-1.415 1.415zM16 26.649a2.683 2.683 0 000-5.364 2.681 2.681 0 000 5.364z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesWifiFilled;